import templateUrl from './edit-onboarding-application-status-modal.html'
import { ILogService } from 'angular';
import { EmployeeService, OnboardingApplicationService } from '../../../../core/services';
import { UtilityService } from '../../../../core/services/utility.service';
import { getExceptionMessage } from '../../../../core/data-utils';

export const EditOnboardingApplicationStatusModalComponent = {
    templateUrl,
    controller: EditOnboardingApplicationStatusController,
    controllerAs: "vm",
    bindings: {
        resolve: "<",
        close: "&",
        dismiss: "&"
    }
}

export const EditOnboardingApplicationStatusModal = {
    component: "apexEditOnboardingApplicationStatusModal",
    windowClass: 'xx-dialog pagespinner',
    size: 'sm',
    backdrop: 'static'
}

function EditOnboardingApplicationStatusController($log: ILogService,
    employeeService: EmployeeService,
    onboardingApplicationService: OnboardingApplicationService,
    utilityService: UtilityService) {
    'ngInject'
    // eslint-disable-next-line @typescript-eslint/no-this-alias
    const vm = this;

    vm.$onInit = onInit;
    vm.employment;
    vm.onboardingApplication; // Read-only. Passed in only so details about the application can be displayed.
    // Indicates that the new status has already been determined, so don't allow the selection to change.
    vm.isAdminView;
    vm.onCancel = onCancel;
    vm.onChangeOnboardingApplicationStatus = onChangeOnboardingApplicationStatus;
    vm.onSave = onSave;
    vm.showReferenceFieldInput = showReferenceFieldInput;
    vm.statusChange; // The status change model that will be written to.
    vm.statuses; // List of statuses that can be selected from.
    vm.terminationDetailsRequired = terminationDetailsRequired;
    vm.terminationReasons;

    return;

    function onInit() {
        // Assign resolved values as bindings.
        vm.onboardingApplication = vm.resolve.onboardingApplication;
        vm.isAdminView = vm.resolve.isAdminView;
        vm.statusChange = vm.resolve.statusChange;
        vm.statuses = vm.resolve.statuses;

        if (vm.onboardingApplication && vm.onboardingApplication.EmployeeID) {
            // Load data in the background, but don't need it to finish loading the page.
            employeeService.retrieveEmployee(vm.onboardingApplication.EmployeeID)
                .then(function (employee) {
                    vm.employment = employee.IcdOffices.filter(function (employment) {
                        return employment.IcdOfficeID === vm.onboardingApplication.IcdOffice.Id;
                    })[0] || null;
                })
                .catch(ex => {
                    $log.warn(
                        `Unable to load employee ${vm.onboardingApplication.EmployeeID} for status change: `
                        + `${vm.onboardingApplication.OnboardingApplicationID}.`,
                        getExceptionMessage(ex));
                });
            employeeService.retrieveTerminationReasons()
                .then(function (terminationReasons) {
                    vm.terminationReasons = terminationReasons;
                })
                .catch(ex => {
                    $log.warn(
                        `Failed to load termination reasons for status change: `
                        + `${vm.onboardingApplication.OnboardingApplicationID}.`,
                        getExceptionMessage(ex));
                });
        }

        if (vm.statusChange.NewStatusID !== 6) {
            vm.statuses = vm.statuses.filter(item => item.OnboardingApplicationStatusID !== 6);
        }

        vm.statusChange.SendStatusChangeMessage = true;
        // Set the status change new status to the corresponding status from the status list.
        vm.statusChange.NewStatus = vm.statuses.filter(function (status) {
            return status.OnboardingApplicationStatusID === vm.statusChange.NewStatusID;
        })[0];
    }

    function onChangeOnboardingApplicationStatus() {
        if (vm.editForm) {
            vm.editForm.$setDirty(true);
        }
    }

    function onCancel() {
        vm.dismiss({ $value: 'cancel' });
    }

    function showReferenceFieldInput(referenceField) {
        const requiredAtStatus = vm.statuses.filter(function (status) {
            return status.OnboardingApplicationStatusID === referenceField.RequiredAtStatusID;
        })[0];
        // Show the reference field as long as the new status is the same time as the required status.
        // However, the field is only required at that specific state.
        return requiredAtStatus && vm.statusChange.NewStatus
            && requiredAtStatus.StatusType === vm.statusChange.NewStatus.StatusType;
    }

    function onSave() {
        if (vm.editForm.$invalid) {
            alert("Please address any validation messages and try again.");
            return;
        }
        const patch = {
            OnboardingApplicationID: vm.onboardingApplication.OnboardingApplicationID,
            OnboardingApplicationStatusID: vm.statusChange.NewStatus.OnboardingApplicationStatusID,
            ReferenceFields: vm.statusChange.ReferenceFields.map(function (reference) {
                return reference.Value;
            }),
            SendStatusChangeMessage: vm.statusChange.SendStatusChangeMessage,
            StatusChangeComments: vm.statusChange.StatusChangeComments,
            TerminationDate: vm.statusChange.TerminationDate ? kendo.format("{0:yyyy-MM-dd}", vm.statusChange.TerminationDate) : null,
            TerminationReasonID: vm.statusChange.TerminationReason ?
                vm.statusChange.TerminationReason.TerminationReasonID : null
        };

        utilityService.showLoading();
        onboardingApplicationService.patchOnboardingApplication(
            // TODO: Fix type definitions that accept Dates, but not stringified dates.
            vm.onboardingApplication.OnboardingApplicationID, patch as any)
            .then(function () {
                return vm.close({
                    onboardingApplication: vm.onboardingApplication,
                    statusChange: vm.statusChange
                });
            })
            .catch(function (ex) {
                console.error(ex);
                alert("Saving failed: " + utilityService.getExceptionMessage(ex));
            })
            .then(function () {
                utilityService.hideLoading();
            });
    }

    function terminationDetailsRequired() {
        // Termination details are required if the application has an employment associated with it,
        // the new status is a termination status, and the previous status was not a termination status.
        return vm.onboardingApplication.EmployeeID
            && vm.employment !== null // Means employment has loaded and was not found, ie, current user can't access it.
            && vm.statusChange.NewStatus.StatusType === 'Terminated'
            && vm.onboardingApplication.StatusHistory[0].Status.StatusType !== 'Terminated'
    }
}
